import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar } from '../../../shared/buttons';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import BancoService from '../../../services/bancoService';
import { Banco } from '../../../shared/model/banco';
import { ProtectedAction } from '../../../AccessControl';

function BancoComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [bancos, setBancos] = useState<Banco[]>([]);

  const bancoService: BancoService = new BancoService();

  const listarTodosBancos = async () => {
    try {
      setLoading(true);
      const responseList = await bancoService.listarTodosBancos();
      setBancos(responseList.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    listarTodosBancos();
  }, []);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        <h5>Parâmetros Cartão &gt; Bancos</h5>
        <ProtectedAction>
          <Button
            onClick={() => navigate('/parametros-banco/inclusao', { state: { id: null } })}
            id="App-button-cor-principal-escura"
          >
            + Novo Banco
          </Button>
        </ProtectedAction>
      </div>
      {loading ? <Spinner loading={loading} /> : (
        <div className="table-responsive">
          <div>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" id="App-header-table">Nr Banco</th>
                  <th scope="col" id="App-header-table">Nome</th>
                  <th scope="col" id="App-header-table">CNPJ</th>
                  <th scope="col" id="App-header-table">Ativo</th>
                  <ProtectedAction> 
                    <th scope="col" id="App-header-table">Alteração</th>
                  </ProtectedAction>
                </tr>
              </thead>
              <tbody>
                {bancos.map((item) => (
                  <tr>
                    <td>{item.numeroBanco}</td>
                    <td>{item.nome}</td>
                    <td>{item.cnpj}</td>
                    <td>{item.ativo ? "Sim" : "Não"}</td>
                    <ProtectedAction> 
                      <td>
                        <Link to={`/parametros-banco/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                    </ProtectedAction> 
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default BancoComponent;